interface ScoreHealthRangeBreakpointLabelsProps {
  displayBreakpoints: string[];
}

export function ScoreHealthRangeBreakpointLabels({ displayBreakpoints }: ScoreHealthRangeBreakpointLabelsProps) {
  return (
    <div className="w-full flex justify-evenly -mb-[3px]">
      {displayBreakpoints.map((point) => (
        <span key={point} className="text-white text-base font-bold h-[19px] w-0 flex justify-center">
          {point}
        </span>
      ))}
    </div>
  );
}
